import React from "react";
import { QRCodeCanvas } from "qrcode.react";
// import LogoHorizontal from "../../../Assets/images/logoHeaderPdf.png";

function QRGenerator(props) {
	const { value, documentId, margin } = props;
	return (
		<div>
			<QRCodeCanvas
				id={documentId}
				value={value}
				size={190}
				bgColor="#FFF"
				fgColor="#000"
				marginSize={margin ? 4 : 0}
				level="L"
				// imageSettings={{
				// 	src: LogoHorizontal,
				//  excavate: true,
				// 	height: 60,
				// 	width: 60,
				// }}
			/>
		</div>
	);
}

export default QRGenerator;
